import { createAsyncThunk } from "@reduxjs/toolkit"
import { Attribute, Campaign, Config, ReviewList } from "../../model/SPAModels/campaigns/campaign.Model"
import { RootState } from "../../root-redux/RootState"
import { postRequest } from "../utils/PostRequest"
import { v4 as uuidv4 } from 'uuid';
import { getRequest } from "../utils/GetRequest";
import { Helper } from "../../feature-components/spa-admin/utils/Help";
import { postRequestReleaseManagement } from "../utils/PostRequestReleaseManagement";
import { CAMPAIGN_APPROVED_BY_FIELD, CAMPAIGN_APPROVED_BY_ID_FIELD, DEFAULT_RECOMMENDATION_TYPE, ENV_PROD, RECOMMENDATION_TYPE_ATTRIBUTE, RecommendationTypeEnum, TARGET_AREA_ATTRIBUTE, SPA_APP_ID, SPA_GENERIC_FIELDS_LIST } from "../../feature-components/spa-admin/SPAConstants";
import { getWorkflowsBySubKeys } from "../GetWorkflows.api";
import { setPendingReview } from "../../feature-components/spa-admin/redux/CampaignDataCart.redux";
import { resetResultList } from "../../feature-components/spa-admin/redux/CampaignQueryBuilder.redux";
import { sendNotificationAboutNewLaunch, sendNotificationAboutUpdate } from "./MEONotification.api";
import { getAllSPAUserObjects } from "./SPAUserObjects.api";

const checkAndGetWorkflowsBySubkey = (dispatch: any, subKey: string) => {
    dispatch(getWorkflowsBySubKeys({ subKeys: subKey }));
    dispatch(setPendingReview(false));
    dispatch(resetResultList());
}

export const postCampaignInSilent = createAsyncThunk<any, void, { state: RootState }>('campaignById/postCampaignInSilent', async (_, {getState, dispatch, rejectWithValue}) => {
    return saveCampaignDetails(getState, dispatch, rejectWithValue);
});

export const postCampaignDetails = createAsyncThunk<any, void, { state: RootState }>('campaignById/postCampaign', async (_, {getState, dispatch, rejectWithValue}) => {
    return saveCampaignDetails(getState, dispatch, rejectWithValue);
});
export const refreshPreSummary = createAsyncThunk<any,{id:string}, { state: RootState }>('/refreshPreSummary', async (configurationDetails:any,{getState}) => {

    const env = getState().env.selectedEnvItem;
var response = await getRequest<string>(`${env}/campaigns/${configurationDetails.id}/preSummary`);
    return response?.data;

});
const sendSPANotification = (dispatch: any, newWorkflowId: string, notificationType: any) => {
    dispatch(notificationType({ workflowId: newWorkflowId })).unwrap().then((result: any) => {
        if(result) {
            console.log(result);
        }
    }).catch((err: any) => {
        console.log(err);
    })
}

const getuserobjects = (dispatch: any, data: any) => {
    if (data && (data['reviewList'] || []).length > 0) {
        const userIds: string[] | undefined = data?.reviewList.map((rList: any) => rList.userIds).flat();
        if (userIds && userIds.length > 0) {
            dispatch(getAllSPAUserObjects(userIds));
        }
    }
}

const saveCampaignDetails = async (getState: any, dispatch: any, rejectWithValue: any) => {

    const env = getState().env.selectedEnvItem;
    
    const campaignState: Campaign = getState().campaignById.campaign!;
    const editCampaignFlag = getState().campaignById.editCampaignFlag;
    let campaign: Campaign = new Campaign();
    const s = getState().campaignById.summary;
    let createdOn = s['CreatedOn']!;
    let isNewCampaign = false;

    if (!campaignState) {
        const newWorkflowId = uuidv4().toString();
        campaign.id = uuidv4().toString();
        campaign.partitionKey = campaign.id;
        campaign.subscriptionKey = s["SubscriptionKey"]!;

        campaign.config = {
            workflowId: newWorkflowId,
            workflowName: s["CampaignName"]
        } as Config;

        campaign.type = 'Campaign';
        campaign.status = 'Draft';
        campaign.data = '';                                                                                                                                                               
        campaign.version = 1;
        campaign.environment = env;
        campaign.family = "";
        campaign.workFlowType = "Campaign";
        campaign.selfServeVersion = "";
        campaign.tenantName = getState().appPersonas.list.find((app: any) => app.appId.map((id: string) => id.toLowerCase()).includes(SPA_APP_ID))?.appName!;
        campaign.typeOfMerge = "Default";
        campaign.defaultMergeRule = "Default";
        campaign.isActionPublish = false;
        campaign.description = s["Description"];
        campaign.tags = s["Tags"]!;
        campaign.createdBy = getState().userDetails.localAccountId;
        campaign.dataIngestion =[];
        campaign.preProcessing = [];
        campaign.delta = [];
        campaign.publish = [];
        campaign.filters = [];
        campaign.inCart = [];
        campaign.outOfCart = [];
        campaign.dataSets = [];
        campaign.reviewList = [];

        isNewCampaign = true;

        // send a mail to spa v-team, About ***new Campaign*** This will help teams to initiate comms to local Area teams to action on SPA. 
        sendSPANotification(dispatch, newWorkflowId, sendNotificationAboutNewLaunch);
        // sendSPANotification(dispatch, newWorkflowId, sendSPANotificationKickOff);
    } 
    else {
        Object.assign(campaign, campaignState);
        if(editCampaignFlag && campaignState.status === 'Published')
        {
            campaign.id = uuidv4().toString();
            campaign.partitionKey = campaign.id;
            campaign.version = campaignState.version + 1;
            createdOn = Helper.getCurrentDatetime();
            campaign.status = 'Draft';
            campaign.postDeployInfo = [];
            campaign.dataIngestion = [];
            campaign.preProcessing = [];
            campaign.delta = [];
            campaign.publish = [];
            campaign.outOfCart = [];
            campaign.preReleaseInfo = [];
        }
        campaign.config = {
            workflowId: campaignState.config.workflowId,
            workflowName: s["CampaignName"]
        } as Config;

        // send a mail to spa v-team, About ***update of Campaign*** This will help teams to initiate comms to local Area teams to action on SPA. 
        sendSPANotification(dispatch, campaignState.config.workflowId, sendNotificationAboutUpdate);
    }
    campaign.description = s["Description"];
    campaign.tags = s["Tags"]!;
    campaign.startOnDate = s["StartOn"]!;
    campaign.expiryDate = s["ExpiryDate"]!;
    campaign.actionByDate = s["ActionByDate"]!;
    campaign.modifiedDate = Helper.getCurrentDatetime()
    campaign.modifiedBy = getState().userDetails.localAccountId;
    const completeRList = campaign.reviewList ? [...campaign.reviewList] : [];

    // Summary Attributes Handler
    /** Generic field like Description is moved into Governance Section and that doesnt need to be added as a Key-Value pair in Summary */
    const summary: Attribute[] = [];
    const configFields = getState().campaignConfig.campaignConfig?.layoutFields.filter((f: any) => f.type !== "hidden" && !SPA_GENERIC_FIELDS_LIST.includes(f.name)).map((f: any) => f.name);
    for(const k in s) {
        if (configFields?.includes(k)) {
            //For ApprovedBy field, we need to save the id and show the name in UI 
            // if(k==CAMPAIGN_APPROVED_BY_FIELD && s[k] && s[k].length > 0) summary.push({key: k, value: s[CAMPAIGN_APPROVED_BY_ID_FIELD]})
            // else
         summary.push({ key: k, value: s[k]! });
        }
    }
    summary.push({ key: 'CampaignType', value: s['CampaignType']!});
    summary.push({ key: RECOMMENDATION_TYPE_ATTRIBUTE, value: s[RECOMMENDATION_TYPE_ATTRIBUTE] || DEFAULT_RECOMMENDATION_TYPE});
    // TargetArea is a hardcoded (non config-driven) field, so it is dropped by the configFields filter above unless explicitly persisted. Only relevant for Local Campaign recommendations.
    if (s[RECOMMENDATION_TYPE_ATTRIBUTE] === RecommendationTypeEnum.LOCAL && s[TARGET_AREA_ATTRIBUTE]) {
        summary.push({ key: TARGET_AREA_ATTRIBUTE, value: s[TARGET_AREA_ATTRIBUTE]! });
    }
    summary.push({ key: 'CreatedOn', value: createdOn});
    campaign.summary = summary;

    if (!getState().userSalesRoles.isApprover) {
        const response = await postRequest<string, Campaign>(`${env}/campaigns`, campaign);
        const data: any = response.data;
        getuserobjects(dispatch, data);
        if ((data["Code"] || "").startsWith('ERR')) {
            return rejectWithValue(data);
        }
        if (isNewCampaign) {
            checkAndGetWorkflowsBySubkey(dispatch, campaign.subscriptionKey);
        }
        dispatch(setPendingReview(false));
        return response.data;
    }
    
    // ReviewList Handler
    let reviewList: ReviewList|undefined = undefined;
    const idx = completeRList.findIndex(rList => rList.userIds.includes(getState().userDetails.localAccountId));
    let NotIncludeIds: string[] = campaign.reviewList.filter(rList => !rList.userIds.includes(getState().userDetails.localAccountId)).map((rList: ReviewList) => rList.list).flat();
    const addList = getState().campaignById.addReviewList.filter((id: string) => !campaign.inCart.includes(id) && !NotIncludeIds.includes(id));
    const deleteList = getState().campaignById.deleteReviewList.filter((id: string) => !campaign.outOfCart.includes(id) && !NotIncludeIds.includes(id));
    const list = addList.concat(deleteList);
    if (idx > -1) {
        const temp = completeRList[idx];
        const attrs = temp.attributes.filter((a: Attribute) => a.key !== 'modifiedDate');
        reviewList = {
            userIds: temp.userIds,
            attributes: [ ...attrs, {key: 'modifiedDate', value: Helper.getCurrentDatetime()}],
            list: list
        }
        completeRList.splice(idx, 1);
    } else if (list.length > 0) {
        reviewList = {
            userIds: [getState().userDetails.localAccountId],
            attributes: [
                {key: 'Area', value: (getState().userSalesRoles.userDetails?.areas || []).join(",")},
                {key: 'modifiedDate', value: Helper.getCurrentDatetime()}
            ],
            list: list
        }
    }
    if (reviewList) {
        completeRList.push(reviewList);
    }
    campaign.reviewList = completeRList;

    const response = await postRequest<string, Campaign>(`${env}/campaigns`, campaign);
    const data: any = response.data;
    getuserobjects(dispatch, data);
    if ((data["Code"] || "").startsWith('ERR')) {
        return rejectWithValue(data);
    }
    checkAndGetWorkflowsBySubkey(dispatch, campaign.subscriptionKey);
    return response.data;
};

export const postCampaignDetailsForRelease = createAsyncThunk<any, Campaign, { state: RootState }>('campaignById/postCampaignDetailsForRelease', async (campaign:Campaign, {getState, dispatch, rejectWithValue}) => {

    const selectedEnv = getState().env.selectedEnvItem ;
    var environment = campaign.environment === "" || campaign.environment === null ? selectedEnv : campaign.environment;
    const modifiedCampaign = {
        ...campaign,
        modifiedDate: Helper.getCurrentDatetime()
    };

    if (Array.isArray(modifiedCampaign.summary)) {
        let releaseSummary = [...modifiedCampaign.summary as Attribute[]];

        const recTypeIdx = releaseSummary.findIndex(a => a.key === RECOMMENDATION_TYPE_ATTRIBUTE);
        if (recTypeIdx === -1) {
            releaseSummary = [
                ...releaseSummary,
                { key: RECOMMENDATION_TYPE_ATTRIBUTE, value: DEFAULT_RECOMMENDATION_TYPE }
            ];
        } else if (!releaseSummary[recTypeIdx].value) {
            releaseSummary = releaseSummary.map((a, i) =>
                i === recTypeIdx ? { ...a, value: DEFAULT_RECOMMENDATION_TYPE } : a
            );
        }

        modifiedCampaign.summary = releaseSummary;
    }
    modifiedCampaign.modifiedBy = getState().userDetails.localAccountId;
    const response = await postRequestReleaseManagement<Campaign, Campaign>(`${environment}/campaigns`, modifiedCampaign);
    const data: any = response.data;
    if ((data["Code"] || "").startsWith('ERR')) {
        return rejectWithValue(data);
    }
    checkAndGetWorkflowsBySubkey(dispatch, campaign.subscriptionKey);
    return response.data;

})
export const getCampaignById = createAsyncThunk<any, string, { state: RootState }>('campaignById/getCampaignById', async (id: string, {getState, dispatch, rejectWithValue}) => {
    const env = getState().env.selectedEnvItem;
    const response = await getRequest<Campaign>(`${env}/campaigns/${id}`);
    const data: any = response.data;
    getuserobjects(dispatch, data);
    if ((data["Code"] || "").startsWith('ERR')) {
        return rejectWithValue(data);
    }
    checkAndGetWorkflowsBySubkey(dispatch, response.data.subscriptionKey);
    return response.data;
})
export const getCampaignByIdandVersion_dev = createAsyncThunk<any,{workflowId:string, version:string}, { state: RootState }>('campaignByIdAndVersion_dev/getCampaignById', async (campaignDetails:any,{getState, dispatch, rejectWithValue}) => {
    const response = await getRequest<Campaign>(`dev/campaigns/${campaignDetails.version}/${campaignDetails.workflowId}`);
    const data: any = response.data;
    if ((data["Code"] || "").startsWith('ERR')) {
        return rejectWithValue(data);
    }
    checkAndGetWorkflowsBySubkey(dispatch, response.data.subscriptionKey);
    return response.data;
})
export const getCampaignByIdandVersion_uat = createAsyncThunk<any,{workflowId:string, version:string}, { state: RootState }>('campaignByIdAndVersion_uat/getCampaignById', async (campaignDetails:any,{getState, dispatch, rejectWithValue}) => {
    const response = await getRequest<Campaign>(`uat/campaigns/${campaignDetails.version}/${campaignDetails.workflowId}`);
    const data: any = response.data;
    if ((data["Code"] || "").startsWith('ERR')) {
        return rejectWithValue(data);
    }
    checkAndGetWorkflowsBySubkey(dispatch, response.data.subscriptionKey);
    return response.data;
})
export const getCampaignByIdandVersion_prod = createAsyncThunk<any,{workflowId:string, version:string}, { state: RootState }>('campaignByIdAndVersion_prod/getCampaignById', async (campaignDetails:any,{getState, dispatch, rejectWithValue}) => {
    const response = await getRequest<Campaign>(`prod/campaigns/${campaignDetails.version}/${campaignDetails.workflowId}`, ENV_PROD);
    const data: any = response.data;
    if ((data["Code"] || "").startsWith('ERR')) {
        return rejectWithValue(data);
    }
    checkAndGetWorkflowsBySubkey(dispatch, response.data.subscriptionKey);
    return response.data;
})
export const getADBRunStatus = createAsyncThunk<any, string, { state: RootState }>('preSummary/getADBRunStatus', async (id: string, {getState, dispatch, rejectWithValue}) => {
    const response = await getRequest<Campaign>(`dev/campaigns/${id}/getRunStatus`);
    const data: any = response.data;
    if ((data["Code"] || "").startsWith('ERR')) {
        return rejectWithValue(data);
    }
    return response.data;
})
